/**
 * html2canvas-pro (our capture library) handles oklch/oklab natively, so
 * the old per-property overrides are no longer needed. We still clear
 * `outline-color` because Tailwind 4's default focus ring uses an oklch
 * value with an alpha channel that some older WebKit builds mispaint as
 * a solid ring over the captured slide content. Zeroing it out is safe —
 * outlines only appear on focused elements, which never happens in a
 * static html2canvas capture.
 */
export function neutralizeOklch(doc: Document): void {
  const style = doc.createElement('style');
  style.setAttribute('data-html2canvas-oklch-fix', '');
  style.textContent = `
    *, *::before, *::after {
      outline-color: transparent !important;
    }
  `;
  doc.head.appendChild(style);
}
